module.exports = __webpack_public_path__ + "img/chatLogo.9d28eab4.webp";